<div class="containerForm" >
    <iframe
    *ngIf="idioma=='es'"
      src="https://firebasestorage.googleapis.com/v0/b/the-campus-56b06.appspot.com/o/Manualuser%2FManual_Alumno_Colegia(ESP).pdf?alt=media&token=9a4808eb-80da-4642-9241-87c8beda3585"
      name="iframe1"
      id="iframe1"
      width="100%"
      height="100%"
    ></iframe>
    <iframe
    *ngIf="idioma!='es'"
      src="https://firebasestorage.googleapis.com/v0/b/the-campus-56b06.appspot.com/o/Manualuser%2FManual_Alumno_Colegia(ESP).pdf?alt=media&token=9a4808eb-80da-4642-9241-87c8beda3585"
      name="iframe1"
      id="iframe1"
      width="100%"
      height="100%"
    ></iframe>
  </div>
  
